const ChkSections = ({ sectionClass = "", children }) => {
  return (
    <div className={`chk-sections ${sectionClass}`}>
      {children}
    </div>
  );
}

export default ChkSections;
